import { createNode, DurationDataType } from '@glueapp/graph-types';
import { toDuration } from '../../utils/temporal';

export const FormatDuration = createNode({
    id: 'Format Duration (ISO)',
    name: 'Format Duration (ISO)',
    description: 'Formats a Duration as an ISO 8601 string (e.g. "P1Y2M3DT4H5M6S")',
    aiDescription:
        'Takes a Duration on the "Duration" port and outputs its ISO 8601 string representation (e.g. "P1Y2M3DT4H5M6S") on the "Text" port.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Duration: DurationDataType,
    },
    outPorts: {
        Text: { kind: 'string' },
    },
    execute: function (input) {
        const duration = toDuration(input.inPorts.Duration);
        return { output: { Text: duration.toString() } };
    },
});
